const styles = {
  formWrapper: {
    marginTop: 52,
    marginBottom: 32,
  },
  form: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  exportButton: {
    fontSize: 10,
    color: '#7f8fa4',
    float: 'right',
    border: 'none',
    textDecoration: 'none',
  },
  toggleWrapper: {
    display: 'flex',
  },
  toggleLabel: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 8px 0 0',
  },
  headingRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 18,
  },
  sectionTitle: {
    '& h2': {
      margin: 0,
    },
  },
}

export default styles



// WEBPACK FOOTER //
// ./src/Containers/Form/City/CityPrograms/CityProgramView/styles.js